if (window.matchMedia("(max-width: 768px)").matches) {
    window.onscroll = function() {
      var pageOffset = document.documentElement.scrollTop || document.body.scrollTop,
          btn = document.getElementById('scrollToTop');
      if (btn) btn.style.display = pageOffset > 1200 ? 'block' : 'none';
  }
} 

function parcelamento() {
  var precoEl = document.querySelector('.product-form__info-item .price--highlight');
  var compareEl = document.querySelector('.product-form__info-item .price--compare');
  var parcelamentoEl = document.querySelector('.parcelamento');

  if (precoEl) {
    var precoText = precoEl.textContent.split('                  ')[0].replace('R$ ', '').replace('R$', '').replace(',', '.').trim();
    var preco = parseFloat(precoText);

    if (compareEl && compareEl.textContent.trim() !== '') {
      var compareText = compareEl.textContent.replace('R$ ', '').replace('R$', '').replace(',', '.').trim();
      var compare = parseFloat(compareText);

      if (!isNaN(compare) && !isNaN(preco) && compare > preco) {
        var precompare = (compare - preco).toFixed(2).replace('.', ',');
        var labelSpan = document.querySelector('.product-label.product-label--on-sale span');
        if (labelSpan) labelSpan.textContent = 'R$ ' + precompare;

        var porcent = ((compare - preco) * 100 / compare).toFixed(2).split('.')[0];
        var labelSale = document.querySelector('.price--highlight .product-label.product-label--on-sale');
        if (labelSale && !labelSale.textContent.includes('%')) labelSale.innerHTML += '-' + porcent + '%';
      }
    }

    if (parcelamentoEl && !isNaN(preco)) {
      var calculo = (preco * 1.1979) / 12;
      parcelamentoEl.innerHTML = '<span>em até 12x de <b>R$ ' + calculo.toFixed(2).replace('.', ',') + '</b></span>';
    }
  }
}

document.addEventListener('change', function(event) {
  if (event.target && event.target.classList && event.target.classList.contains('block-swatch__radio')) {
    setTimeout(parcelamento, 150);
  }
});

// TROCA DE IMAGEM POR COR
document.addEventListener('DOMContentLoaded', function() {
  var productForm = document.querySelector('.product-form');
  if (!productForm) return;

  productForm.addEventListener('change', function(event) {
    if (!event.target.classList.contains('product-form__single-selector')) return;

    var selectedOptions = [];
    productForm.querySelectorAll('.product-form__single-selector:checked, select.product-form__single-selector').forEach(function(input) {
      selectedOptions.push(input.value.toLowerCase().trim());
    });

    var colorValue = selectedOptions[0];
    if (!colorValue) return;

    // Busca miniatura pelo data-group-value
    var matchedThumb = document.querySelector('.product-gallery__thumbnail[data-group-value="' + colorValue + '"]');

    // Fallback: busca pelo alt da imagem
    if (!matchedThumb) {
      document.querySelectorAll('.product-gallery__thumbnail').forEach(function(thumb) {
        var img = thumb.querySelector('img');
        if (img && img.alt && img.alt.toLowerCase().indexOf(colorValue) !== -1) {
          matchedThumb = thumb;
        }
      });
    }

    if (!matchedThumb) return;

    // Atualiza seleção visual
    document.querySelectorAll('.product-gallery__thumbnail').forEach(function(t) {
      t.classList.remove('is-nav-selected');
    });
    matchedThumb.classList.add('is-nav-selected');

    // Troca imagem principal
    var mediaId = matchedThumb.getAttribute('data-media-id');
    if (mediaId) {
      document.querySelectorAll('.product-gallery__carousel-item').forEach(function(item) {
        item.classList.remove('is-selected');
      });
      var targetItem = document.querySelector('.product-gallery__carousel-item[data-media-id="' + mediaId + '"]');
      if (targetItem) targetItem.classList.add('is-selected');
    }
  });
});